import brakes from './brakes.svg';
import brakes_selected from './brakes-selected.svg';
import diagnosis from './diagnosis.svg';
import diagnosis_selected from './diagnosis-selected.svg';
import oil_change from './oil-change.svg';
import oil_change_selected from './oil-change-selected.svg';
import replace_battery from './replace-battery.svg';
import replace_battery_selected from './replace-battery-selected.svg';
import replace_starter from './replace-starter.svg';
import replace_starter_selected from './replace-starter-selected.svg';
import used_car from './used-car.svg';
import used_car_selected from './used-car-selected.svg';

export default {
  brakes,
  brakes_selected,
  diagnosis,
  diagnosis_selected,
  oil_change,
  oil_change_selected,
  replace_battery,
  replace_battery_selected,
  replace_starter,
  replace_starter_selected,
  used_car,
  used_car_selected,
};
